import { ReactNode } from 'react';

interface DeckButtonContainerProps {
  onClickButton: (value: string) => void;
  children: ReactNode;
}

const DeckButtonContainer = ({ onClickButton, children }: DeckButtonContainerProps) => (
  <div className="w-full">
    {/* Desktop / tablet: buttons on sides */}
    <div className="hidden sm:flex items-center justify-center gap-6 xl:gap-10">
      <div className="z-50">
        <button
          type="button"
          aria-label="No"
          className="flex items-center justify-center border-2 rounded-full w-12 h-12 sm:w-14 sm:h-14 bg-error-500"
          onClick={() => {
            onClickButton('left');
          }}
        >
          <img src="/img/thumbs_down_lg.png" className="w-5 h-5 sm:w-6 sm:h-6" alt="No" />
        </button>
      </div>

      {children}

      <div className="z-50">
        <button
          type="button"
          aria-label="Yes"
          className="flex items-center justify-center border-2 rounded-full w-12 h-12 sm:w-14 sm:h-14 bg-success-500"
          onClick={() => {
            onClickButton('right');
          }}
        >
          <img src="/img/thumbs_up_lg.png" className="w-5 h-5 sm:w-6 sm:h-6" alt="Yes" />
        </button>
      </div>
    </div>

    {/* Mobile: image first, buttons underneath */}
    <div className="flex sm:hidden flex-col items-center gap-3">
      {children}
      <div className="flex items-center justify-center gap-6">
        <button
          type="button"
          aria-label="No"
          className="flex items-center justify-center border-2 rounded-full w-12 h-12 bg-error-500"
          onClick={() => {
            onClickButton('left');
          }}
        >
          <img src="/img/thumbs_down_lg.png" className="w-5 h-5" alt="No" />
        </button>
        <button
          type="button"
          aria-label="Yes"
          className="flex items-center justify-center border-2 rounded-full w-12 h-12 bg-success-500"
          onClick={() => {
            onClickButton('right');
          }}
        >
          <img src="/img/thumbs_up_lg.png" className="w-5 h-5" alt="Yes" />
        </button>
      </div>
    </div>
  </div>
);

export { DeckButtonContainer };
